import { DrawingShapeState } from './drawingShape.slice.types';

import { RootState } from '~/redux/store';

export const selectNeedRedrawCanvas = ({
  drawingShape,
}: RootState): DrawingShapeState['needRedrawCanvas'] =>
  drawingShape.needRedrawCanvas;

export const selectPreventRepricing = ({
  drawingShape,
}: RootState): DrawingShapeState['preventRepricing'] =>
  drawingShape.preventRepricing;

export const selectActiveDrawingObject = ({
  drawingShape,
}: RootState): DrawingShapeState['activeDrawingObject'] =>
  drawingShape.activeDrawingObject;
